import type { PropsWithChildren } from 'react';
import MuiList from '@mui/material/List';

export { default as CardListItem } from './CardListItem';
export { default as ListItem } from './ListItem';
export { default as SkeletonListItem } from './SkeletonListItem';
export { default as SkeletonListItems } from './SkeletonListItems';

export type { ListItemProps } from './ListItem';
export type { SkeletonListItemProps } from './SkeletonListItem';
export type { SkeletonListItemsProps } from './SkeletonListItems';

export interface ListProps extends PropsWithChildren {
  className?: string;
}

export default function List({ className, ...props }: ListProps) {
  return <MuiList className={className} {...props} />;
}
